import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { ArrowDownToLine, X } from "lucide-react";

export const InputsEditor = ({ strategy, allStrategies, onChange }) => {
  const options = allStrategies.filter((s) => s.id !== strategy.id).flatMap((s) => (s.work_products || []).map((wp) => ({ ...wp, strategy: s.name })));
  const ids = strategy.input_work_product_ids || [];
  const selected = ids.map((id) => options.find((o) => o.id === id)).filter(Boolean);
  const available = options.filter((o) => !ids.includes(o.id));
  const save = async (next) => {
    try {
      onChange((await api.put(`/strategies/${strategy.id}/inputs`, { work_product_ids: next })).data);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Opslaan mislukt");
    }
  };
  return (
    <div data-testid="inputs-editor">
      <div className="font-mono text-[11px] uppercase tracking-widest text-zinc-500 mb-2">Benodigde input ({selected.length})</div>
      <div className="flex flex-wrap gap-1.5 items-center">
        {selected.map((o) => (
          <span key={o.id} className="inline-flex items-center gap-1 border border-zinc-900 px-2 py-0.5 text-xs" data-testid="input-work-product-chip">
            <ArrowDownToLine className="h-3 w-3" /> {o.name} <span className="text-zinc-400">· {o.strategy}</span>
            <button onClick={() => save(ids.filter((i) => i !== o.id))} className="text-zinc-400 hover:text-red-600" data-testid="remove-input-button"><X className="h-3 w-3" /></button>
          </span>
        ))}
        {available.length > 0 ? (
          <Select value="" onValueChange={(v) => save([...ids, v])}>
            <SelectTrigger className="rounded-none border-dashed border-zinc-400 h-7 w-auto text-xs px-2 gap-1" data-testid="add-input-select">
              <SelectValue placeholder="+ input werkproduct" />
            </SelectTrigger>
            <SelectContent>
              {available.map((o) => (
                <SelectItem key={o.id} value={o.id}>{o.name} · {o.strategy}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        ) : (
          selected.length === 0 && <span className="text-sm text-zinc-400">Geen werkproducten van andere strategieën beschikbaar.</span>
        )}
      </div>
    </div>
  );
};
